const TURNSTILE_TEST_SITE_KEY = "1x00000000000000000000AA";
const TURNSTILE_TEST_SECRET_KEY = "1x0000000000000000000000000000000AA";

export function getTurnstileSiteKey(): string {
  if (process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY) {
    return process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
  }

  if (process.env.NODE_ENV === "development") {
    return TURNSTILE_TEST_SITE_KEY;
  }

  return "";
}

export function getTurnstileSecretKey(): string {
  if (process.env.TURNSTILE_SECRET_KEY) {
    return process.env.TURNSTILE_SECRET_KEY;
  }

  if (process.env.NODE_ENV === "development") {
    return TURNSTILE_TEST_SECRET_KEY;
  }

  return "";
}
